import moment from "moment";
import "moment-timezone";
import React, { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import OrderSummary from "../ticketOrderSummary/OrderSummary";
import "../ticketOrderSummary/ticketOrderSummary.css";
import Select from "react-select";
import "./AddMoreTickets.css";
import {
  Checkbox,
  CircularProgress,
  FormControlLabel,
} from "@material-ui/core";
import * as constants from "Constants";
import { IoClose } from "react-icons/io5";
import {
  ticktesCartItem,
  CreateShoppingCartSession,
  PersistShoppingCartSession,
  currentEventDetails
} from "Actions/eventActions";
import { useLayoutEffect } from "react";
import TimeOutScreen from "../SuccessFull/TimeOutScreen";
import EventSlotsScheduler from "../EventSlotsScheduler/EventSlotsScheduler";
import BundleScheduler from "../BundleScheduler/BundleScheduler";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { axiosE } from "Service/service";
import { default as momentTz } from "moment-timezone";
import { v4 as uuidv4 } from "uuid";

const AddMoreTickets = ({
                          setOpenCheckOut,
                          cartItems,
                          discountData,
                          CreateShoppingCartSession,
                          currentEventDetails,
                          ticktesCartItem,
                          dispatch,
                          setContinueToCheckOut,
                          minutes,
                          setMinutes,
                          seconds,
                          shoppingCartDetails,
                          paymentIntent,
                          Token,
                          setRecurringData,
                          recurringData,
                          selectedOption,
                          setSelectedOption,
                          hasCheckoutQuery,
                          paymentMessage
                        }) => {
  const [showOrderSummary, setShowOrderSummary] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bundleSelectedQuantity, setBundleSelectedQuantity] = useState({});
  const [currentTicket, setCurrentTicket] = useState("");
  const [remainingUtilization, setRemainingUtilization] = useState(0);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [ticketData, setTicketData] = useState([]);
  const [currentAddonQuantity, setCurrentAddonQuantity] = useState();
  const [showAddonListDetail, setShowAddonListDetail] = useState({
    ticketId: "",
    addonId: "",
  });

  const searchParams = new URLSearchParams(window.location.search);
  const isEmbed = searchParams.get("embed") === "true";

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    content: {
      position: "relative",
      background: "#fff",
      padding: "20px",
      borderRadius: "10px",
      maxWidth: "90vw",
      maxHeight: "90vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "#c31491",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      padding: "5px 10px",
      cursor: "pointer",
    },
  };

    useEffect(() => {
    setRemainingUtilization(Number(discountData?.RemainingUtilization));
  }, [discountData]);

  const handleAddonCheckboxChange = (addon, ticketId, person) => {
    const updatedCartItems = cartItems.map((item) => {
      if (item.TicketId === ticketId) {
        const updatedAddon = Array.isArray(item.addon) ? [...item.addon] : [];
        const groupAddons = item.GroupAddons;
        let addOnTotal = item.AddOnTotal || 0;
        const maxAllowed = Number(item.maxAddonsPerTicket) || 0;

        const existingIndex = updatedAddon.findIndex(
            (entry) => entry.person === person && entry.AddOnId === addon.AddOnId
        );

        const addonId = addon.AddOnId;
        const updatedQuantities = { ...currentAddonQuantity };
        const quantityAvailable = Number(addon.QuantityAvailable) - addon.Sold;
        if (updatedQuantities[addonId] === undefined) {
          updatedQuantities[addonId] =
              quantityAvailable > 0 ? quantityAvailable : 0;
        }

        if (existingIndex !== -1) {
          updatedAddon.splice(existingIndex, 1);
          addOnTotal -= 1;
          groupAddons[person - 1] = (groupAddons[person - 1] || 0) - 1;
          updatedQuantities[addonId] += 1;
        } else {
          if (maxAllowed === 0 || addOnTotal < maxAllowed) {
            if (updatedQuantities[addonId] > 0) {
              updatedAddon.push({ ...addon, person });
              addOnTotal += 1;
              groupAddons[person - 1] = (groupAddons[person - 1] || 0) + 1;
              updatedQuantities[addonId] -= 1;
            }
          }
        }

        setCurrentAddonQuantity(updatedQuantities);

        return {
          ...item,
          addon: updatedAddon,
          AddOnTotal: addOnTotal,
          GroupAddons: groupAddons,
        };
      }

      return item;
    });

    dispatch(ticktesCartItem(updatedCartItems));
  };

  useEffect(() => {
    if (!cartItems || cartItems.length === 0) return;
    const updatedQuantities = {};
    cartItems.forEach((item) => {
      item.AddOns?.forEach((addon) => {
        const addonId = addon.AddOnId;

        const totalAvailable = Number(addon.QuantityAvailable) - addon.Sold;
        const initialAvailable = totalAvailable;

        if (!updatedQuantities[addonId]) {
          updatedQuantities[addonId] = initialAvailable;
        }

        // Subtract the number of times this addon is already selected
        const selectedCount = item.addon?.filter((a) => a.AddOnId === addonId)
            ?.length || 0;

        updatedQuantities[addonId] = Math.max(
            updatedQuantities[addonId] - selectedCount,
            0
        );
      });
    });
    setCurrentAddonQuantity(updatedQuantities);
  }, []);


  const handleChange = (
      Quantity,
      ticket,
      recurringData,
      recurringQuantityChange
  ) => {
    //  coming from api response
    let groupIds = [];
    let groupAddons = [];
    if (Quantity.value > 0) {
      groupIds = Array.from({ length: Quantity.value }).map((_, index) => {
        const uuid = uuidv4();
        return `${uuid}`;
      });
      groupAddons = Array(Quantity.value).fill(0);
    }

    const exist = cartItems?.find((x) => x.TicketId === ticket.TicketId);
    if (exist && exist.addon?.length > 0) {
      const updatedQuantities = { ...currentAddonQuantity };
      if (ticket.RecurringTicket === "True") {
        if (ticket.isBundle) {
          if (recurringQuantityChange) {
            exist.addon.forEach((a) => {
              if (updatedQuantities[a.AddOnId] !== undefined) {
                updatedQuantities[a.AddOnId]++;
              } else {
                updatedQuantities[a.AddOnId] = 1;
              }
            });
          }
        } else {
          exist.addon.forEach((a) => {
            if (updatedQuantities[a.AddOnId] !== undefined) {
              updatedQuantities[a.AddOnId]++;
            } else {
              updatedQuantities[a.AddOnId] = 1;
            }
          });
        }
      } else {
        exist.addon.forEach((a) => {
          if (updatedQuantities[a.AddOnId] !== undefined) {
            updatedQuantities[a.AddOnId]++;
          } else {
            updatedQuantities[a.AddOnId] = 1;
          }
        });
      }

      setCurrentAddonQuantity(updatedQuantities);
    }

    if (exist && Quantity.value > 0) {
      if (ticket.RecurringTicket === "True") {
        if (ticket.isBundle) {
          const isRecurringDateAvailable =
              recurringData !== undefined &&
              recurringData !== null &&
              recurringData.selectedSlots !== undefined &&
              recurringData.selectedSlots !== null;
          setBundleSelectedQuantity((prevQuantities) => ({
            ...prevQuantities,
            [ticket.TicketId]: Quantity.value,
          }));
          if (bundleSelectedQuantity[ticket.TicketId] !== Quantity.value) {
            setRecurringData({ selectedDate: null, selectedSlots: null });
          }
          dispatch(
              ticktesCartItem(
                  cartItems?.map((x) =>
                      x.TicketId === ticket.TicketId
                          ? {
                            ...exist,
                            Quantity: Quantity.value,
                            recurringDate: true,
                            ...recurringData,
                            ...(recurringQuantityChange && {
                              addon: [],
                              AddOnTotal: 0,
                              GroupIds: groupIds,
                              GroupAddons: groupAddons,
                              selectedSlots: null,
                            }),
                          }
                          : x
                  )
              )
          );
        } else {
          dispatch(
              ticktesCartItem(
                  cartItems?.map((x) =>
                      x.TicketId === ticket.TicketId
                          ? {
                            ...exist,
                            Quantity: Quantity.value,
                            ...recurringData,
                            addon: [],
                            AddOnTotal: 0,
                            GroupIds: groupIds,
                            GroupAddons: groupAddons,
                          }
                          : x
                  )
              )
          );
        }
      } else {
        dispatch(
            ticktesCartItem(
                cartItems?.map((x) =>
                    x.TicketId === ticket.TicketId
                        ? {
                          ...exist,
                          Quantity: Quantity.value,
                          addon: [],
                          AddOnTotal: 0,
                          GroupIds: groupIds,
                          GroupAddons: groupAddons,
                        }
                        : x
                )
            )
        );
      }
    } else {
      if (Quantity.value > 0) {
        if (ticket.RecurringTicket === "True") {
          if (ticket.isBundle) {
            setBundleSelectedQuantity((prevQuantities) => ({
              ...prevQuantities,
              [ticket.TicketId]: Quantity.value,
            }));
          }
          if (ticket.isBundle) {
            if (
                recurringData !== undefined &&
                recurringData !== null &&
                recurringData.selectedSlots !== undefined &&
                recurringData.selectedSlots !== null
            ) {
              dispatch(
                  ticktesCartItem([
                    ...cartItems,
                    {
                      ...ticket,
                      Quantity: Quantity.value,
                      ...recurringData,
                      ...(recurringQuantityChange && {
                        addon: [],
                        AddOnTotal: 0,
                        GroupIds: groupIds,
                        GroupAddons: groupAddons,
                      }),
                      recurringDate: true,
                    },
                  ])
              );
            } else {
              dispatch(
                  ticktesCartItem([
                    ...cartItems,
                    {
                      ...ticket,
                      Quantity: Quantity.value,
                      ...(recurringQuantityChange && {
                        addon: [],
                        AddOnTotal: 0,
                        GroupIds: groupIds,
                        GroupAddons: groupAddons,
                      }),
                      ...recurringData,
                      recurringDate: false,
                    },
                  ])
              );
            }
          } else if (!ticket.isBundle) {
            dispatch(
                ticktesCartItem([
                  ...cartItems,
                  {
                    ...ticket,
                    Quantity: Quantity.value,
                    ...recurringData,
                    addon: [],
                    AddOnTotal: 0,
                    GroupIds: groupIds,
                    GroupAddons: groupAddons,
                    recurringDate: true,
                  },
                ])
            );
          }
        } else {
          dispatch(
              ticktesCartItem([
                ...cartItems,
                {
                  ...ticket,
                  Quantity: Quantity.value,
                  addon: [],
                  AddOnTotal: 0,
                  GroupIds: groupIds,
                  GroupAddons: groupAddons,
                },
              ])
          );
        }
      } else {
        if (ticket.isBundle) {
          setBundleSelectedQuantity((prevQuantities) => ({
            ...prevQuantities,
            [ticket.TicketId]: Quantity.value,
          }));
        }
        dispatch(
            ticktesCartItem(
                cartItems.filter((x) => x.TicketId !== ticket.TicketId)
            )
        );
      }
    }
  };

    const convertTimeUtcToLocal = (time) => {
        const UtcToLocal = moment
            .utc(time)
            .local()
            .format("MM/DD/YYYY hh:mm:ss A");
        var Time = moment(UtcToLocal, "MM/DD/YYYY hh:mm:ss A");

        const convertedTime = Time.tz(currentEventDetails?.TimeZone);
        return moment(convertedTime).format("MM/DD/YYYY hh:mm:ss A");
    };

  useEffect(() => {
    if (currentEventDetails !== null && shoppingCartDetails === null) {
      localStorage.setItem("additionalInfo", null);
      setLoading(true);
      dispatch(CreateShoppingCartSession(currentEventDetails?.EventId))
          .then((data) => {

            let newData = { ...data };
            const ticketDataUtctoLocal = newData?.CartItems?.map((ticketdata) => {
              return {
                ...ticketdata,
                ActiveDate: convertTimeUtcToLocal(ticketdata.ActiveDate),
                InActiveDate: convertTimeUtcToLocal(ticketdata.InActiveDate),
              };
            });

            setTicketData(ticketDataUtctoLocal);

            dispatch({
              type: "CREATE_SHOPPING_DETAILS",
              payload: { ...data, CartItems: ticketDataUtctoLocal },
            });
            setLoading(false);
          })
          .catch(() => {});
    }
  }, [currentEventDetails, shoppingCartDetails]);

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => {
        window.removeEventListener("resize", updateSize);
      };
    }, []);
    return size;
  }
  const [width, height] = useWindowSize();

  const istToUtc = (datetime) => {
    const timeZone = currentEventDetails?.TimeZone;
    const istDateTime = moment.tz(datetime, "MM/DD/YYYY hh:mm:ss A", timeZone);
    const utcDateTime = istDateTime.clone().tz("UTC");
    return utcDateTime;
  };

  const checkDateWithinRange = (startDateTime, endDateSTime) => {
    const nowUtc = moment.utc();
    const startUtc = istToUtc(startDateTime);
    const endUtc = istToUtc(endDateSTime);
    return nowUtc.isBetween(startUtc, endUtc);
  };

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

    const recurringDate =
      recurringData !== undefined &&
      recurringData !== null &&
      recurringData.selectedDate != null;

  return (
      <div style={{ height: "100%" }}>
        {loading ? (
            <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
            >
              <CircularProgress size={50} color="secondary" />
            </div>
        ) : minutes === 0 && seconds === 0 ? (
            <TimeOutScreen
                setMinutes={setMinutes}
                setOpenCheckOut={setOpenCheckOut}
                setContinueToCheckOut={setContinueToCheckOut}
                hasCheckoutQuery={hasCheckoutQuery}
            />
        ) : (
            <div className="add-more-container">
              <div class="container_1">
                <div
                    style={{
                      position: "relative",
                    }}
                    id="header"
                >
                  <h4 id="header_h3">{currentEventDetails?.Title}</h4>
                  <div
                      style={{
                        padding:
                            paymentIntent?.paymentId !== null ? "5px 0px" : "8px 0px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                  >
                    {paymentIntent?.paymentId !== null && (
                        <small style={{ color: "rgb(255, 38, 38)" }}>
                          Time left {minutes < 10 ? `0${minutes}` : minutes}:
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </small>
                    )}
                  </div>

                    <h4 id="header_h4">
                        {isEmbed
                            ? `${moment(convertTimeUtcToLocal(currentEventDetails?.StartDateTime, currentEventDetails?.TimeZone)).format("llll")} - ${moment(convertTimeUtcToLocal(currentEventDetails?.EndDateTime, currentEventDetails?.TimeZone)).format("llll")}`
                            : `${moment(currentEventDetails?.StartDateTime).format("llll")} - ${moment(currentEventDetails?.EndDateTime).format("llll")}`
                        }
                    </h4>
                    {width <= 800 && !Token && !hasCheckoutQuery ? (
                      <div
                          onClick={() => setOpenCheckOut(false)}
                          className="order_close"
                      >
                        <IoClose size={20} />
                      </div>
                  ) : null}
                </div>
                <div className="underline" />
              {/* 🔥 Banner goes here */}
              {paymentMessage && (
                  <div
                      style={{
                          backgroundColor: "#fdecea", // light red
                          color: "#b71c1c",
                          padding: "10px 20px",
                          borderRadius: 8,
                          margin: "10px 0",
                          textAlign: "center",
                          fontWeight: "500",
                      }}
                  >
                      {paymentMessage}
                  </div>
              )}
                <div class={
                    isEmbed
                        ? "col_9_embed"
                        : "col_9"
                }>
                  {currentEventDetails?.SeatingChartImage !== undefined &&
                      currentEventDetails.SeatingChartImage !== null &&
                      currentEventDetails?.SeatingChartImage !== "" && (
                          <div
                              style={{
                                textAlign: "center",
                                height: "55%",
                                padding: "10px",
                              }}
                          >
                            <img
                                src={currentEventDetails?.SeatingChartImage}
                                alt="Seating Chart"
                                style={{
                                  cursor: "pointer",
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "contain",
                                }}
                                onClick={() =>
                                    openImageModal(currentEventDetails?.SeatingChartImage)
                                }
                                className="responsive-image"
                            />
                          </div>
                      )}

                  {/* Modal for showing the image popup */}
                  {isImageModalOpen && (
                      <div style={modalStyles.overlay} onClick={closeImageModal}>
                        <div
                            style={modalStyles.content}
                            onClick={(e) => e.stopPropagation()}
                        >
                          <img
                              src={selectedImage}
                              alt="Seating Chart Popup"
                              style={{
                                maxHeight: "90vh",
                                maxWidth: "90vw",
                              }}
                          />
                          <div onClick={closeImageModal} className="order_close">
                            <IoClose size={20} />
                          </div>
                        </div>
                      </div>
                  )}
                  <div>
                    {shoppingCartDetails?.CartItems?.length > 0 &&
                        shoppingCartDetails?.CartItems?.map((item, idx) => (
                            <div key={idx}>
                              <RenderTicktsData
                                  discountData={discountData}
                                  cartItems={cartItems}
                                  item={item}
                                  session={shoppingCartDetails?.CartSession}
                                  TimeZone={currentEventDetails?.TimeZone}
                                  handleChange={handleChange}
                                  handleAddonCheckboxChange={handleAddonCheckboxChange}
                                  selectedOption={selectedOption}
                                  checkDateWithinRange={checkDateWithinRange}
                                  currentTicket={currentTicket}
                                  bundleSelectedQuantity={bundleSelectedQuantity}
                                  dispatch={dispatch}
                                  recurringData={recurringData}
                                  setSelectedOption={setSelectedOption}
                                  setBundleSelectedQuantity={setBundleSelectedQuantity}
                                  index={idx}
                                  currentAddonQuantity={currentAddonQuantity}
                                  setShowAddonListDetail={setShowAddonListDetail}
                                  showAddonListDetail={showAddonListDetail}
                                  currentEventDetails={currentEventDetails}
                              />

                              {item?.RecurringTicket === "True" &&
                                  checkDateWithinRange(
                                      item.ActiveDate,
                                      item.InActiveDate
                                  ) &&
                                  (item.isBundle ? (
                                      (() => {
                                        // const isRecData = cartItems.find((x) => x.TicketId === item.TicketId);
                                        if (bundleSelectedQuantity[item.TicketId] > 0) {
                                          return (
                                              <BundleScheduler
                                                  item={item}
                                                  key={item?.TicketId}
                                                  cartItems={recurringDate ? cartItems : []}
                                                  handleChange={handleChange}
                                                  selectedOption={selectedOption}
                                                  setSelectedOption={setSelectedOption}
                                                  setRecurringData={setRecurringData}
                                                  currentTicket={currentTicket}
                                                  setCurrentTicket={setCurrentTicket}
                                                  dispatch={dispatch}
                                                  recurringData={recurringData}
                                                  bundleSelectedQuantity={
                                                    bundleSelectedQuantity
                                                  }
                                              />
                                          );
                                        }
                                      })()
                                  ) : (
                                      <EventSlotsScheduler
                                          item={item}
                                          key={item?.TicketId}
                                          cartItems={cartItems}
                                          handleChange={handleChange}
                                          selectedOption={selectedOption}
                                          setSelectedOption={setSelectedOption}
                                          setRecurringData={setRecurringData}
                                          currentTicket={currentTicket}
                                          setCurrentTicket={setCurrentTicket}
                                          dispatch={dispatch}
                                          recurringData={recurringData}
                                      />
                                  ))}
                            </div>
                        ))}
                  </div>
                </div>

                <div className="language-button">
                  <div id="footer">
                    {width <= 800 && cartItems.length > 0 ? (
                        <a
                            className="open_summury_btn"
                            onClick={() => setShowOrderSummary(!showOrderSummary)}
                            href="#"
                        >
                          {showOrderSummary ? "Hide Summary " : "View Summary"}
                        </a>
                    ) : null}

                    <button
                        id="submit_btn"
                        style={{
                          backgroundColor:
                              (cartItems.length > 0 &&
                                  (cartItems.every((cartitem) => !cartitem.isBundle)
                                      ? (currentEventDetails?.EventColor !== undefined && currentEventDetails.EventColor !== "") ? currentEventDetails.EventColor : "#c31491"
                                      : cartItems.every(
                                          (cartitem) =>
                                              cartitem.isBundle &&
                                              parseInt(cartitem.SlotPerBundle) ===
                                              (cartitem.selectedSlots !== undefined &&
                                                  cartitem.selectedSlots !== null &&
                                                  cartitem.selectedSlots.length)
                                      )
                                          ? (currentEventDetails?.EventColor !== undefined && currentEventDetails.EventColor !== "") ? currentEventDetails.EventColor : "#c31491"
                                          : cartItems.some((cartitem) => !cartitem.isBundle) &&
                                          cartItems.some(
                                              (cartitem) =>
                                                  cartitem.isBundle &&
                                                  parseInt(cartitem.SlotPerBundle) ===
                                                  (cartitem.selectedSlots !== undefined &&
                                                      cartitem.selectedSlots !== null &&
                                                      cartitem.selectedSlots.length)
                                          )
                                              ? (currentEventDetails?.EventColor !== undefined && currentEventDetails.EventColor !== "") ? currentEventDetails.EventColor : "#c31491"
                                              :  ((currentEventDetails?.EventColor !== undefined && currentEventDetails.EventColor !== "") ? currentEventDetails.EventColor : "#c31491") + "66" )) ||
                              ((currentEventDetails?.EventColor !== undefined && currentEventDetails.EventColor !== "") ? currentEventDetails.EventColor : "#c31491") + "66",
                        }}
                        onClick={() =>
                            (cartItems.length > 0 &&
                                (cartItems.every((cartitem) => !cartitem.isBundle)
                                    ? setContinueToCheckOut(true)
                                    : cartItems.every(
                                        (cartitem) =>
                                            cartitem.isBundle &&
                                            parseInt(cartitem.SlotPerBundle) ===
                                            (cartitem.selectedSlots !== undefined &&
                                                cartitem.selectedSlots !== null &&
                                                cartitem.selectedSlots.length)
                                    )
                                        ? setContinueToCheckOut(true)
                                        : cartItems.some((cartitem) => !cartitem.isBundle) &&
                                        cartItems.some(
                                            (cartitem) =>
                                                cartitem.isBundle &&
                                                parseInt(cartitem.SlotPerBundle) ===
                                                (cartitem.selectedSlots !== undefined &&
                                                    cartitem.selectedSlots !== null &&
                                                    cartitem.selectedSlots.length)
                                        )
                                            ? setContinueToCheckOut(true)
                                            : null)) ||
                            null
                        }
                    >
                      {constants.Text.continue}
                    </button>
                  </div>
                </div>
              </div>

              <OrderSummary
                  Token={Token}
                  selectedOption={selectedOption}
                  setShowOrderSummary={setShowOrderSummary}
                  showOrderSummary={showOrderSummary}
                  isPromo={true}
                  setOpenCheckOut={setOpenCheckOut}
                  hasCheckoutQuery={hasCheckoutQuery}
              />
            </div>
        )}
      </div>
  );
};

const RenderTicktsData = ({
                            item,
                            session,
                            handleChange,
                            handleAddonCheckboxChange,
                            TimeZone,
                            cartItems,
                            selectedOption,
                            setSelectedOption,
                            checkDateWithinRange,
                            setBundleSelectedQuantity,
                            bundleSelectedQuantity,
                            recurringData,
                            index,
                            currentAddonQuantity,
                            setShowAddonListDetail,
                            showAddonListDetail,
                            currentEventDetails
                          }) => {
  const [isSaleOn, setIsSaleOn] = useState(false);
  const [saleEnded, setSaleEnded] = useState(false);
  const [isShowInput, setIsShowInput] = useState(false);
  const [availableQnty, setAvailableQnty] = useState(0);

  const [currentCartItems, setCurrentCartitems] = useState({});
  const handleShowAddonList = (ticketId, addon) => {
    setShowAddonListDetail({ ticketId: ticketId, addonId: addon?.AddOnId });
  };

  useEffect(() => {
    const isRecData = cartItems.filter((x) => x.TicketId === item?.TicketId);
    if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate === selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot !== null
    ) {
      setAvailableQnty(isRecData[0]?.selectedSlot?.AvailableTickets);
      setIsShowInput(true);
      if (isRecData[0]?.isBundle && isRecData[0]?.Quantity !== null) {
        setBundleSelectedQuantity((prevQuantities) => ({
          ...prevQuantities,
          [isRecData[0].TicketId]: isRecData[0]?.Quantity,
        }));
      }
    } else if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate === selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot === null
    ) {
      setIsShowInput(false);
    } else if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate !== selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot !== null
    ) {
      setAvailableQnty(isRecData[0]?.selectedSlot?.AvailableTickets);
      setIsShowInput(true);
      if (isRecData[0]?.isBundle && isRecData[0]?.Quantity !== null) {
        setBundleSelectedQuantity((prevQuantities) => ({
          ...prevQuantities,
          [isRecData[0].TicketId]: isRecData[0]?.Quantity,
        }));
      }
    } else if (
        selectedOption?.TicketId === item?.TicketId &&
        selectedOption?.selectedSlot === null
    ) {
      setIsShowInput(false);
    } else {
      // console.log({ selectedOption, cartItems, isRecData, recurringData });
    }
  }, [selectedOption?.selectedDate]);

  useEffect(() => {
    const isRecData = cartItems.filter((x) => x.TicketId === item?.TicketId);
    if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate === selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot !== null
    ) {
      setAvailableQnty(isRecData[0]?.selectedSlot?.AvailableTickets);
      setIsShowInput(true);
      // handleRecurringTicketDefaultValue();
    } else if (
        isRecData?.length > 0 &&
        isRecData[0]?.selectedDate === selectedOption?.selectedDate &&
        isRecData[0]?.selectedSlot == null
    ) {
      setIsShowInput(false);
    } else {
      if (
          selectedOption?.item?.TicketId === item?.TicketId &&
          selectedOption?.selectedSlot !== null
      ) {
        setAvailableQnty(selectedOption?.selectedSlot?.AvailableTickets);
        setIsShowInput(true);
        // handleRecurringTicketDefaultValue();
      } else if (
          selectedOption?.TicketId === item?.TicketId &&
          selectedOption?.selectedSlot == null
      ) {
        setIsShowInput(false);
      } else if (selectedOption?.TicketId === item?.TicketId) {
        setIsShowInput(false);
      } else if (
          isRecData?.length <= 0 &&
          selectedOption?.selectedSlot === null
      ) {
        if (selectedOption?.TicketId !== item?.TicketId) {
          setIsShowInput(false);
        } else {
          setIsShowInput(true);
          // handleRecurringTicketDefaultValue();
        }
      } else {
        // console.log({ selectedOption, cartItems, isRecData });
      }
    }
  }, [selectedOption?.selectedSlot]);

  useEffect(() => {
    if (
        selectedOption?.isStateNull &&
        selectedOption?.TicketId === item?.TicketId
    ) {
      setIsShowInput(false);
    }
  }, [selectedOption]);

  useEffect(() => {
    if (cartItems && cartItems.length > 0) {
      const matchingCartItem = cartItems.find(
          (cartItem) => cartItem.TicketId === item.TicketId
      );
      setCurrentCartitems(matchingCartItem);
    } else {
      setCurrentCartitems();
    }
  }, [cartItems]);

  useEffect(() => {
    if (
        TimeZone &&
        moment(item?.ActiveDate, "MM/DD/YYYY hh:mm:ss A").isAfter(
            moment(
                moment().tz(TimeZone).format("MM/DD/YYYY hh:mm:ss A"),
                "MM/DD/YYYY hh:mm:ss A"
            )
        )
    ) {
      setIsSaleOn(true);
    }
    if (
        TimeZone &&
        moment(item?.InActiveDate, "MM/DD/YYYY hh:mm:ss A").isBefore(
            moment(
                moment().tz(TimeZone).format("MM/DD/YYYY hh:mm:ss A"),
                "MM/DD/YYYY hh:mm:ss A"
            )
        )
    ) {
      setSaleEnded(true);
    }
  }, []);

    const handleNumberOnlyInput = (e) => {
    if (e.nativeEvent.code === "KeyE" || e.nativeEvent.code === "Minus") {
      e.preventDefault();
    }
  };

  const defaultValue = cartItems?.find((p) => p.TicketId === item?.TicketId);

  const customStyles = {
    // control represent the select component
    control: (provided) => ({
      ...provided,
      width: "100px",
    }),
  };

  const handleSetSelectedOption = (val) => {
    setSelectedOption((prevState) => {
      return {
        ...prevState,
        qnty: val,
        selectedSlot: null,
        TicketId: item?.TicketId,
      };
    });
  };

  const handleRecurringTicketDefaultValue = () => {
    if (item.RecurringTicket === "True" && !item.isBundle) {
      const exist = cartItems?.find((x) => x.TicketId === item.TicketId);
      if (exist) {
        handleChange(
            { value: exist.Quantity, label: exist.Quantity },
            item,
            recurringData
        );
      } else {
        handleChange({ value: 1, label: 1 }, item, recurringData);
      }
    }
  };

  const isAddonOutOfStockAndNotSelected = (addon, currentCartItems) => {
    const isSelected = currentCartItems?.addon?.some(
        (a) => a.AddOnId === addon.AddOnId
    );

    const totalAvailable =  currentAddonQuantity?.[addon.AddOnId] >= 0  ? currentAddonQuantity?.[addon.AddOnId] : Number(addon.QuantityAvailable) - addon.Sold;
    const remainingQty = totalAvailable - addon.Reserved;
    return remainingQty <= 0 && !isSelected;
  };

  return (
      <>
        <div
            key={item.EventId}
            class="body_row"
            style={{ paddingTop: index !== 0 ? "10%" : "0" }}
        >
          <div class="col_10">
            <h4 style={{ fontSize: 22, marginBottom: 10, fontWeight: 600 }}>
              {item.Title}
            </h4>
            {item.Description !== "" && (
                <h4
                    style={{
                      fontSize: 15,
                      marginBottom: 10,
                      color: "darkgray",
                      wordWrap: "break-word",
                    }}
                >
                  {item.Description}
                </h4>
            )}
            <h5 style={{ fontSize: 20, marginBottom: 5, fontWeight: 600 }}>
              {item.TicketType === "0"
                  ? "Free"
                  : `${session.CurrencySymbol}${Intl.NumberFormat(undefined, {
                    minimumFractionDigits: 2,
                  }).format(item?.Price)}`}
            </h5>

            <div>
              {!isSaleOn &&
                  item?.RecurringTicket === "False" &&
                  !item.isBundle &&

                  (
                  <p style={{ color: "#878f99", fontWeight: 600 }}>
                    {" "}
                    {constants.Text.salesEndOn}{" "}
                    {moment(item?.InActiveDate).format("MMM DD, yyyy")}
                  </p>
              )}
            </div>

            {item.isBundle ? (
                bundleSelectedQuantity[item.TicketId] > 0 ? (
                    cartItems?.find(
                        (x) =>
                            x.TicketId === item.TicketId &&
                            (x.selectedSlots !== undefined &&
                                x.selectedSlots !== null &&
                                x.selectedSlots.length) === parseInt(item.SlotPerBundle)
                    ) ? (
                        <div>
                          {!isSaleOn && (
                              <p style={{ color: "#47c94d", fontWeight: 600 }}>
                                {" "}
                                {constants.Text.bundleTicketSelectionSuccessMessage1}
                                {item.SlotPerBundle}
                                {constants.Text.bundleTicketSelectionSuccessMessage2}
                              </p>
                          )}
                        </div>
                    ) : (
                        <div>
                          {!isSaleOn && (
                              <p style={{ color: "#FF0000", fontWeight: 600 }}>
                                {" "}
                                {constants.Text.bundleTicketMessage1}
                                {cartItems?.find(
                                    (x) =>
                                        x.TicketId === item.TicketId &&
                                        x.selectedSlots !== undefined &&
                                        x.selectedSlots !== null &&
                                        x.selectedSlots.length
                                )
                                    ? cartItems.find((x) => x.TicketId === item.TicketId)
                                        .selectedSlots.length
                                    : 0}
                                {"/"}
                                {item.SlotPerBundle}
                                {constants.Text.bundleTicketMessage2}
                              </p>
                          )}
                        </div>
                    )
                ) : (
                    <div>
                      {!isSaleOn && (
                          <p style={{ fontWeight: 600 }}>
                            {" Please select the number of people attending."}
                          </p>
                      )}
                    </div>
                )
            ) : (
                ""
            )}
          </div>
          <div class="col_2">
            <div className="ticket_menu_options">
              {saleEnded && Number(item?.AvailableTicket) !== 0 && (
                  <p
                      style={{
                        fontWeight: 600,
                        color: "rgb(135, 143, 153)",
                        bottom: -6,
                        left: 36,
                        fontSize: 14,
                        padding: "20px 0px",
                        textAlign: "right",
                      }}
                  >
                    {constants.Text.ticketSaleEnd}
                  </p>
              )}

                {item?.RecurringTicket !== "True" &&
                    (
                        (Number(item?.AvailableTicket) === 0 && Number(item?.ReservedTicket) === 0) ||
                        (Number(item?.MinTicketRequired) > 0 &&
                            Number(item?.MinTicketRequired) > Number(item?.AvailableTicket))
                    ) && (
                        <p
                            style={{
                                fontWeight: 600,
                                color: "rgb(135, 143, 153)",
                                bottom: -6,
                                left: 36,
                                fontSize: 14,
                                padding: "20px 0px",
                                textAlign: "right",
                            }}
                        >
                            {constants.Text.soldOut}
                        </p>
                    )}

                {item?.RecurringTicket === "True" &&
              selectedOption?.availableSlots?.length > 0
                  ? selectedOption?.availableSlots?.every(
                  (obj) =>
                      obj.TicketId === item?.TicketId && obj.AvailableTickets == 0
              ) && (
                  <p
                      style={{
                        fontWeight: 600,
                        color: "rgb(135, 143, 153)",
                        bottom: -6,
                        left: 36,
                        fontSize: 14,
                        padding: "20px 0px",
                        textAlign: "right",
                      }}
                  >
                    {constants.Text.soldOut}
                  </p>
              )
                  : ""}

              {item?.RecurringTicket !== "True" &&
                  Number(item?.AvailableTicket) === 0 &&
                  Number(item?.ReservedTicket) !== 0 && (
                      <p
                          style={{
                            fontWeight: 600,
                            color: "rgb(135, 143, 153)",
                            bottom: -6,
                            left: 36,
                            fontSize: 14,
                            padding: "20px 0px",
                            textAlign: "right",
                          }}
                      >
                        {constants.Text.Reserved}
                      </p>
                  )}

              {isSaleOn && (
                  <p
                      style={{
                        fontWeight: 600,
                        color: "rgb(135, 143, 153)",
                        bottom: -6,
                        left: 36,
                        fontSize: 14,
                        textAlign: "right",
                        padding: "20px 0px",
                      }}
                  >
                    {`On Sale ${moment(item?.ActiveDate).format("MMM DD")} at
                   ${moment(item?.ActiveDate).format("hh:mm A")}`}
                  </p>
              )}

              {
                  (item?.RecurringTicket !== "True" && Number(item?.AvailableTicket) !== 0)
                  ||  item?.isBundle ? (
                      <React.Fragment>
                        {
                            !isSaleOn && !saleEnded && (
                                item?.isBundle ? (
                                    // BUNDLE TICKET SELECT
                                    <Select
                                        styles={customStyles}
                                        components={{
                                          IndicatorSeparator: () => null,
                                        }}
                                        isSearchable={false}
                                        onKeyDown={handleNumberOnlyInput}
                                        value={{
                                          value: (() => {
                                            const isRecData = cartItems.find(
                                                (x) => x.TicketId === item.TicketId
                                            );
                                            return isRecData
                                                ? isRecData.Quantity
                                                : bundleSelectedQuantity[item.TicketId] || 0;
                                          })(),
                                          label: (() => {
                                            const isRecData = cartItems.find(
                                                (x) => x.TicketId === item.TicketId
                                            );
                                            return isRecData
                                                ? isRecData.Quantity
                                                : bundleSelectedQuantity[item.TicketId] || 0;
                                          })(), // Use defaultValue
                                        }}
                                        // cartItems?.find((x) => x.TicketId === item.TicketId) ? bundleSelectedQuantity[item.TicketId] || 0, // Use defaultValue
                                        onChange={(val) => {
                                          const isRecData = cartItems.filter(
                                              (x) => x.TicketId === item?.TicketId
                                          );
                                          if (isRecData.length > 0) {
                                            handleChange(val, item, null, true);
                                            if (val.value == 0) {
                                              handleSetSelectedOption(val);
                                            }
                                          } else {
                                            handleChange(val, item, null, true);
                                          }
                                        }}
                                        options={[...Array(Number(16)).keys()].map((i) => {
                                          return { value: i, label: i };
                                        })}
                                    />
                                ) : (
                                    // NON-BUNDLE TICKET SELECT
                                    (() => {
                                        const available = Number(item?.AvailableTicket) || 0;
                                        const minRequired = Number(item?.MinTicketRequired) || 0;

                                        // ❌ Don't render dropdown if required tickets exceed available
                                        if (minRequired > 0 && minRequired > available) {
                                            return null;
                                        }

                                        // ✅ Build dropdown options
                                        const end = Math.min(available, 15);
                                        const arr = [{ value: 0, label: 0 }]; // always allow 0

                                        // start from minRequired if > 0, else from 1 (to avoid duplicate 0)
                                        const start = minRequired > 0 ? minRequired : 1;

                                        for (let i = start; i <= end; i++) {
                                            arr.push({ value: i, label: i });
                                        }

                                        return (
                                            <Select
                                                styles={customStyles}
                                                components={{ IndicatorSeparator: () => null }}
                                                isSearchable={false}
                                                onKeyDown={handleNumberOnlyInput}
                                                value={{
                                                    value:
                                                        defaultValue === undefined
                                                            ? 0
                                                            : cartItems.length > 0
                                                                ? Number(defaultValue?.Quantity)
                                                                : 0,
                                                    label:
                                                        defaultValue === undefined
                                                            ? 0
                                                            : cartItems.length > 0
                                                                ? defaultValue?.Quantity
                                                                : 0,
                                                }}
                                                onChange={(val) => {
                                                    handleChange(val, item);
                                                }}
                                                options={arr}
                                            />
                                        );
                                    })()
                                )
                            )
                        }
                      </React.Fragment>
              ) : null}

              {item?.RecurringTicket === "True" && !item?.isBundle ? (
                  <React.Fragment>
                    {checkDateWithinRange(item?.ActiveDate, item?.InActiveDate) &&
                        isShowInput && (
                            <Select
                                styles={customStyles}
                                components={{
                                  IndicatorSeparator: () => null,
                                }}
                                isSearchable={false}
                                onKeyDown={handleNumberOnlyInput}
                                value={{
                                  value:
                                      defaultValue === undefined
                                          ? 1
                                          : cartItems.length > 0
                                              ? Number(defaultValue?.Quantity)
                                              : 0,
                                  label:
                                      defaultValue === undefined
                                          ? 1
                                          : cartItems.length > 0
                                              ? defaultValue?.Quantity
                                              : 0,
                                }}
                                onChange={(val) => {
                                  const isRecData = cartItems.filter(
                                      (x) => x.TicketId === item?.TicketId
                                  );
                                  if (isRecData.length > 0) {
                                    handleChange(val, item, {
                                      selectedDate: isRecData[0]?.selectedDate,
                                      selectedSlot: isRecData[0]?.selectedSlot,
                                    });
                                    if (val.value == 0) {
                                      handleSetSelectedOption(val);
                                    }
                                  } else {
                                    handleChange(val, item, recurringData);
                                  }
                                }}
                                options={[
                                  ...Array(
                                      Number(
                                          Number(availableQnty) > 15
                                              ? 16
                                              : Number(availableQnty) + 1
                                      )
                                  ).keys(),
                                ].map((i) => {
                                  return { value: i, label: i };
                                })}
                            />
                        )}
                  </React.Fragment>
              ) : null}
            </div>
          </div>
        </div>
        {currentCartItems?.TicketId === item.TicketId &&
        item?.AddOns?.length > 0 ? (
            <div className="add-on-container">
              {item.AddOns?.filter((addon) => {
                const totalAvailable = Number(addon.QuantityAvailable) - addon.Sold;
                if (totalAvailable <= 0) return false;
                return true;
              })?.map((addon, index) => (
                  <>
                    <div>
                      <div
                          key={index}
                          style={{
                            width: "100%",
                            minHeight: "50px",
                            display: "flex",
                            gap: "10px",
                          }}
                      >
                        <div
                            style={{
                              borderRadius: "10px",
                              border: `5px solid ${addon.Color}`,
                              height: "auto",
                            }}
                        ></div>
                        <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                              paddingLeft: addon.color ? "0px" : "20px",
                            }}
                        >
                          <div>
                            <p style={{ fontSize: "16px", fontWeight: "700" }}>
                              {addon.Name}
                            </p>
                            {addon.StartDateTime && addon.EndDateTime && TimeZone ? (
                                <p>
                                  {moment
                                      .utc(addon.StartDateTime)
                                      .tz(TimeZone)
                                      .format("MM/DD/YYYY")}{" "}
                                  -{" "}
                                  {moment
                                      .utc(addon.EndDateTime)
                                      .tz(TimeZone)
                                      .format("MM/DD/YYYY")}{" "}
                                  from{" "}
                                  {moment
                                      .utc(addon.StartDateTime)
                                      .tz(TimeZone)
                                      .format("h:mm A")}{" "}
                                  -{" "}
                                  {moment
                                      .utc(addon.EndDateTime)
                                      .tz(TimeZone)
                                      .format("h:mm A")}
                                </p>
                            ) : null}
                            <p>{addon.Description}</p>
                            {(() => {
                              const isAddonSelected = currentCartItems?.addon?.some(
                                  (a) => a.AddOnId === addon.AddOnId
                              );
                              const numberOfAddonSelected =
                                  currentCartItems?.addon?.filter(
                                      (a) => a.AddOnId === addon.AddOnId
                                  )?.length || 0;

                              const totalAvailable =
                                  currentAddonQuantity?.[addon.AddOnId] >= 0  ? currentAddonQuantity?.[addon.AddOnId] : Number(addon.QuantityAvailable) - addon.Sold;;
                              const remainingQty = totalAvailable - addon.Reserved;

                              if (
                                  isAddonSelected &&
                                  remainingQty === 0 &&
                                  currentCartItems.Quantity > numberOfAddonSelected
                              ) {
                                return (
                                    <p style={{ color: "gray", fontWeight: "500" }}>
                                      Only {numberOfAddonSelected} addons can be
                                      selected
                                    </p>
                                );
                              } else if (
                                  !isAddonSelected &&
                                  totalAvailable > 0 &&
                                  remainingQty <= 0
                              ) {
                                return (
                                    <p style={{ color: "gray", fontWeight: "500" }}>
                                      Addons are in process of being purchased by
                                      another user
                                    </p>
                                );
                              }else if (!isAddonSelected && totalAvailable <=0 ){
                                return (
                                    <p style={{ color: "gray", fontWeight: "500" }}>
                                      {constants.Text.soldOut}
                                    </p>
                                );
                              }

                              return null;
                            })()}
                          </div>
                          {showAddonListDetail.addonId === addon.AddOnId &&
                          showAddonListDetail.ticketId === item.TicketId ? (
                              <RemoveIcon
                                  onClick={() => handleShowAddonList("", "")}
                                  style={{
                                    background: "white",
                                    borderRadius: "50%",
                                    color: (currentEventDetails?.EventColor !== undefined && currentEventDetails?.EventColor !== "") ? currentEventDetails?.EventColor : "#b60eb6",
                                    width: "30px",
                                    height: "30px",
                                    padding: "5px",
                                    border: `2px solid ${(currentEventDetails?.EventColor && currentEventDetails?.EventColor !== "")
                                        ? currentEventDetails?.EventColor
                                        : "#b60eb6"}`,
                                    boxShadow: `0px 1px 2px 0px ${(currentEventDetails?.EventColor && currentEventDetails.EventColor !== "")
                                        ? currentEventDetails.EventColor
                                        : "#ee59ff"}`,
                                    cursor: "pointer",
                                  }}
                              />
                          ) : (
                              <AddIcon
                                  onClick={() => {
                                    const totalAvailable = currentAddonQuantity?.[addon.AddOnId] >= 0  ? currentAddonQuantity?.[addon.AddOnId] : Number(addon.QuantityAvailable) - addon.Sold;
                                    const remainingQty = totalAvailable - addon.Reserved;
                                    const isSelected = currentCartItems?.addon?.some(
                                        (a) => a.AddOnId === addon.AddOnId
                                    );

                                    // Only allow click if some stock is available or already selected
                                    if (remainingQty > 0 || isSelected) {
                                      handleShowAddonList(item.TicketId, addon);
                                    }
                                  }}
                                  style={{
                                    background: "white",
                                    borderRadius: "50%",
                                    color: isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                        ? "gray"
                                        : (currentEventDetails?.EventColor !== undefined && currentEventDetails.EventColor !== "") ? currentEventDetails.EventColor : "#b60eb6",
                                    width: "30px",
                                    height: "30px",
                                    padding: "5px",
                                    border: `2px solid ${
                                        isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                            ? "gray"
                                            : (currentEventDetails?.EventColor !== undefined && currentEventDetails.EventColor !== "") ? currentEventDetails.EventColor : "#b60eb6"
                                    }`,
                                    boxShadow: isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                        ? "none"
                                        : `0px 1px 2px 0px ${(currentEventDetails?.EventColor && currentEventDetails.EventColor !== "")
                                            ? currentEventDetails.EventColor
                                            : "#ee59ff"}`,
                                    cursor: isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                        ? "not-allowed"
                                        : "pointer",
                                    pointerEvents: isAddonOutOfStockAndNotSelected(addon, currentCartItems)
                                        ? "none"
                                        : "auto",
                                  }}
                              />
                          )}
                        </div>
                      </div>

                      {showAddonListDetail.addonId === addon.AddOnId &&
                      showAddonListDetail.ticketId === item.TicketId ? (
                          <div className="add-on-item">
                            {Array.from({ length: currentCartItems?.Quantity }).map(
                                (_, i) => {
                                  const isAlreadySelected = currentCartItems?.addon?.some(
                                      (a) => a.person === i + 1 && a.AddOnId === addon.AddOnId
                                  );

                                  const groupLimitReached =
                                      Number(currentCartItems.MaxAddOnsPerTicket) > 0 &&
                                      !isAlreadySelected &&
                                      currentCartItems.GroupAddons?.[i] >=
                                      Number(currentCartItems.MaxAddOnsPerTicket);

                                  const totalAvailable = currentAddonQuantity?.[addon.AddOnId] >= 0  ? currentAddonQuantity?.[addon.AddOnId] : Number(addon.QuantityAvailable) - addon.Sold;
                                  const remainingQty = totalAvailable - addon.Reserved;

                                  const isReservedOutOfStock = remainingQty <= 0 && !isAlreadySelected;

                                  const isDisabled = groupLimitReached || isReservedOutOfStock;

                                  return (
                                      <div
                                          key={i}
                                          style={{
                                            display: "flex",
                                            gap: "35px",
                                            alignItems: "center",
                                            margin: "8px 0px",
                                            paddingLeft: "10px"
                                          }}
                                      >
                                        <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              opacity: isDisabled ? 0.5 : 1,
                                              color: isDisabled ? "grey" : "inherit",
                                            }}
                                        >
                                          <label className="custom-checkbox-wrapper" style={{
                                              "--checkbox-color": currentEventDetails?.EventColor && currentEventDetails.EventColor !== ""
                                                  ? currentEventDetails.EventColor
                                                  : "#851679"
                                          }}>
                                            <input
                                                type="checkbox"
                                                // Stop the browser from focusing the checkbox on mouse/touch down → prevents scroll jump
                                                onMouseDown={(e) => e.preventDefault()}
                                                onTouchStart={(e) => e.preventDefault()}
                                                checked={currentCartItems?.addon?.some(
                                                    (a) =>
                                                        a.person === i + 1 &&
                                                        a.AddOnId === addon.AddOnId
                                                )}
                                                onChange={(e) => {
                                                    handleAddonCheckboxChange(
                                                        addon,
                                                        item.TicketId,
                                                        i + 1
                                                    )
                                                    e.target.blur();
                                                }}
                                                disabled={isDisabled}
                                            />
                                            <span className="custom-checkbox"></span>
                                          </label>
                                          <div
                                              style={{
                                                fontSize: "14px",
                                                fontWeight: "600",
                                              }}
                                          >
                                            {`${session.CurrencySymbol}${Intl.NumberFormat(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 2,
                                                }
                                            ).format(addon?.Price)}`}
                                          </div>
                                        </div>
                                        <div
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: "600",
                                              color: isDisabled ? "grey" : "inherit",
                                              opacity: isDisabled ? 0.5 : 1,
                                            }}
                                        >
                                          Add to {item.Title} Ticket {i + 1}
                                        </div>
                                      </div>
                                  );
                                }
                            )}
                          </div>
                      ) : null}
                    </div>
                  </>
              ))}
            </div>
        ) : null}
      </>
  );
};

const mapStateToProps = (state) => {
  return {
    results: state.loginResponse.results,
    isLoggedIn: state.loginResponse.isLoggedIn,
    currentEventDetails: state.eventReducer.currentEventDetails,
    cartItems: state.eventReducer.cartData,
    discountData: state.eventReducer.discountData,
    shoppingCartDetails: state.eventReducer.createshoppingCartDetails,
    paymentIntent: state.eventReducer.paymentIntent,
  };
};
const matchDispatchToProps = (dispatch) => {
  return {
    PersistShoppingCartSession,
    CreateShoppingCartSession,
    ticktesCartItem,
    dispatch,
  };
};
export default connect(mapStateToProps, matchDispatchToProps)(AddMoreTickets);
